export default __webpack_public_path__ + "static/EverydayFooterBanner-43a39637b778e5b65c95baa9d847594c.png";